import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fc4c2c0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=6fc4c2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4c2c0",
  null
  
)

export default component.exports